import React, { useEffect } from "react";
import { useAPIs } from "../../apis/APIsConfig";
import { useForm } from "../../utils/hooks";
import InputMask from "react-input-mask";
import GlobalLoading from "../common/GlobalLoading";
import { fileToBase64 } from "../../utils/utilities";
import FileUploader from "../common/FileUploader";
import { useGlobalStore } from "../../utils/global";
import { sendJobRequest } from "../../services/jobs";

const PublicJob = () => {
  useAPIs();
  const { showNotification } = useGlobalStore();

  const [formState, setError, changeHandler, reset] = useForm({
    nombre: "",
    apellido: "",
    email: "",
    principal: "",
    celular: "",
    otro: "",
    posicion: "",
    cv: null,
  });

  useEffect(() => {
    var launcher = document.getElementById("launcher");
    launcher?.remove();

    var botprofrm = document.getElementById("botprofrm");
    botprofrm?.remove();
  }, []);

  function disableButton() {
    return (
      !formState.data.nombre ||
      !formState.data.apellido ||
      !formState.data.email ||
      formState.data.principal.replaceAll("_", "").length !== 10
    );
  }

  function submitForm() {
    sendJobRequest(formState.data).then((res) => {
      if (res && res.data.successed) {
        showNotification({
          isError: false,
          title: "Solicitud enviada satisfactoriamente",
          duration: 2000,
        });
        reset();
      } else if (res && res.data) {
        showNotification({
          isError: false,
          title: res.data.message[0].message,
          duration: 2000,
        });
      }
    });
  }

  return (
    <>
      <GlobalLoading />
      <div className="block pt-6 md:pt-14 pb-10">
        <h1 className="text-primary-100 font-bold mb-2">Empleos</h1>
        <p className="text-gray-70 text-body-1 font-body font-normal">
          Con el fin de realizar nuevas incorporaciones a su organización, AFP
          Crecer desarrolla diferentes procesos de selección en función de los
          perfiles profesionales necesarios en cada momento.
        </p>
      </div>

      <form
        className="block space-y-8"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="form-group">
          <label>Nombre(s)</label>
          <input
            type="text"
            name="nombre"
            className="form-control large"
            placeholder="Juan"
            required
            value={formState.data.nombre}
            onChange={changeHandler("nombre")}
          />
          {formState.errors.nombre && (
            <p className="error">{formState.errors.nombre}</p>
          )}
        </div>

        <div className="form-group">
          <label>Apellido(s)</label>
          <input
            type="text"
            name="apellido"
            className="form-control large"
            placeholder="Perez"
            required
            value={formState.data.apellido}
            onChange={changeHandler("apellido")}
          />
          {formState.errors.apellido && (
            <p className="error">{formState.errors.apellido}</p>
          )}
        </div>

        <div className="form-group">
          <label>Principal</label>
          <InputMask
            type="text"
            className="form-control large"
            placeholder="000-000-0000"
            value={formState.data.principal}
            onChange={changeHandler("principal", undefined, "-")}
            mask="999-999-9999"
            maskPlaceholder={"_"}
          />
          {formState.errors.principal && (
            <p className="error">{formState.errors.principal}</p>
          )}
        </div>

        <div className="form-group">
          <label>Celular</label>
          <InputMask
            type="text"
            className="form-control large"
            placeholder="000-000-0000"
            value={formState.data.celular}
            onChange={changeHandler("celular", undefined, "-")}
            mask="999-999-9999"
            maskPlaceholder={"_"}
          />
          {formState.errors.celular && (
            <p className="error">{formState.errors.celular}</p>
          )}
        </div>

        <div className="form-group">
          <label>Otro</label>
          <InputMask
            type="text"
            className="form-control large"
            placeholder="000-000-0000"
            value={formState.data.otro}
            onChange={changeHandler("otro", undefined, "-")}
            mask="999-999-9999"
            maskPlaceholder={"_"}
          />
          {formState.errors.otro && (
            <p className="error">{formState.errors.otro}</p>
          )}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control large"
            placeholder="ejemplo@gmail.com"
            required
            value={formState.data.email}
            onChange={changeHandler("email")}
          />
          {formState.errors.email && (
            <p className="error">{formState.errors.email}</p>
          )}
        </div>

        <div className="form-group">
          <label>Posición</label>
          <input
            type="text"
            name="posicion"
            className="form-control large"
            required
            value={formState.data.posicion}
            onChange={changeHandler("posicion")}
          />
          {formState.errors.posicion && (
            <p className="error">{formState.errors.posicion}</p>
          )}
        </div>

        <div className="form-group">
          <label>Adjuntar archivo</label>
          <FileUploader
            multiple={true}
            maxSizeMB={2}
            accept={".pdf,.doc,.docx"}
            onFileSelectSuccess={(files) => {
              if (files && files.length) {
                let cv;
                new Promise((resolve) => {
                  files.forEach(async (doc: File) => {
                    cv = (await fileToBase64(doc)).split(";base64,")[1];
                    resolve(cv);
                  });
                }).then((res) => {
                  changeHandler("cv", res)();
                });
              } else {
                changeHandler("cv", null)();
              }
            }}
            onFileSelectError={({ error }) => {
              showNotification({
                title: "Error",
                message: error,
                isError: true,
                duration: 0,
              });
            }}
          />
        </div>

        <button
          type="button"
          onClick={submitForm}
          disabled={disableButton()}
          className="btn btn-primary btn-large"
        >
          Enviar
        </button>
      </form>
    </>
  );
};

export default PublicJob;
